export const authenticationConstants = {
  AUTH_LOGIN_REQUEST: 'AUTH_LOGIN_REQUEST',
  AUTH_LOGIN_SUCCESS: 'AUTH_LOGIN_SUCCESS',
  AUTH_LOGIN_FAILURE: 'AUTH_LOGIN_FAILURE',

  AUTH_SET_PERMISSIONS: 'AUTH_SET_PERMISSIONS',

  AUTH_SET_TOKEN: 'AUTH_SET_TOKEN',
  AUTH_CLEAR: 'AUTH_CLEAR',

  AUTH_SHOW_ACCOUNT_DOMAIN: 'AUTH_SHOW_ACCOUNT_DOMAIN'
};